import { useState } from 'react'
import ReactDOM from 'react-dom'
import { Toolbar as MuiToolbar } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    appBar: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        paddingBlock: 'var(--store-appbar-padding, 8px)',
        borderBottom: 2,
        borderColor: 'primary.main',
    },
}

/**
 * Portal component that renders children into the app-bar DOM element.
 * Uses lazy state initialization to get the DOM element once at mount time.
 *
 * @param {{ children: React.ReactNode, sx: object|array|function|null }} props - Component props
 * @returns {React.ReactPortal|null} Portal to app-bar element or null if not ready
 */
const AppBarPortal = ({ children, sx = null }) => {
    // Lazy initialization - runs once during initial render to get DOM element
    const [appBarElement] = useState(() => document.getElementById('app-bar'))

    if (!appBarElement) {
        return null
    }

    return ReactDOM.createPortal(
        <MuiToolbar sx={[classes.appBar, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</MuiToolbar>,
        appBarElement
    )
}

AppBarPortal.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default AppBarPortal
